import { useSuspenseQuery } from '@apollo/client';
import type { FC } from 'react';
import { Suspense, useEffect } from 'react';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { Column, Row } from '@xing-com/xing-grid';

import { ModuleError } from '../components/module-error/module-error';
import { NewsList } from '../components/news-list/news-list';
import { NewsListSkeleton } from '../components/news-list/news-list.skeleton';
import { NewsContextProvider } from '../contexts/news-context/news-context';
import { EntityPageModuleDocument } from '../graphql/queries/news-sub-module-query.gql-types';

import * as Styled from './news-detail.style';

const NewsDetailInner: FC = () => {
  const { pageContext } = usePageContext();
  const { pageId } = pageContext ?? {};
  const { data, error, refetch } = useSuspenseQuery(EntityPageModuleDocument, {
    variables: { id: pageId ?? '', moduleType: 'news' },
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
  });

  useEffect(() => {
    if (typeof window !== 'undefined') window.scrollTo(0, 0);
  }, []);

  if (error) {
    return <ModuleError refetch={refetch} />;
  }

  return (
    <NewsContextProvider
      isDetailPage={true}
      hasSubpage={data?.entityPageModule?.properties?.hasSubpage}
    >
      <Styled.Wrapper>
        <NewsList />
      </Styled.Wrapper>
    </NewsContextProvider>
  );
};

const Fallback: FC = () => {
  return (
    <NewsContextProvider isDetailPage={true}>
      <Styled.Wrapper>
        <Row>
          <Column sizeDesktop={10} offsetDesktop={1} size={12}>
            <NewsListSkeleton loadingSkeletonCount={3} showActors={false} />
          </Column>
        </Row>
      </Styled.Wrapper>
    </NewsContextProvider>
  );
};

export const NewsDetail: FC = () => {
  return (
    <Suspense fallback={<Fallback />}>
      <NewsDetailInner />
    </Suspense>
  );
};
